import Product from '@/entities/Product';

export default class ProductService {
  constructor(db) {
    this.db = db;
  }

  async listBySupplierAndShopId(supplierId, shopId) {
    const snap = await this.db
      .collection('shops')
      .doc(shopId)
      .collection('products')
      .where('supplierId', '==', supplierId)
      .get();
    const list = [];
    snap.forEach((doc) => list.push(new Product({ ...doc.data(), id: doc.id })));
    return list;
  }
}
